import { render } from "./Drawer.vue?vue&type=template&id=389e492f&scoped=true&ts=true"
import script from "./Drawer.vue?vue&type=script&lang=ts"
export * from "./Drawer.vue?vue&type=script&lang=ts"

import "./Drawer.vue?vue&type=style&index=0&id=389e492f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389e492f"]])

export default __exports__